import React, { useContext, useEffect, useState } from 'react'
import Chart from "react-apexcharts";
import axiosClient from '../../axios/axiosClient';
import { toast } from 'react-toastify';
import Analyticscard from '../../components/app/analyticscard';
import AuthContext from '../../context/AuthContext';
import { Link } from 'react-router-dom';

function ProjectOfficer() {
    const [dashboardData, setDashboardData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [analyticsData, setAnalyticsData] = useState([]);
    const {user} = useContext(AuthContext)
    const [chartData, setChartData] = useState({
        options: {
            chart: {
                id: "basic-bar",
                toolbar: {
                    show: true
                }
            },
            xaxis: {
                categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
            },
            stroke: {
                curve: 'smooth',
                width: 2,
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shade: 'light',
                    type: "vertical",
                    shadeIntensity: 0.5,
                    opacityFrom: 0.7,
                    opacityTo: 0.2,
                }
            },
            dataLabels: {
                enabled: true,
                formatter: function (val) {
                    return val;
                }
            },
            title: {
                text: 'Cases Overview',
                align: 'left'
            }
        },
        series: [
            {
                name: "Cases",
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            }
        ]
    });

    // Generate years array
    const years = Array.from(
        { length: new Date().getFullYear() - 2019 },
        (_, i) => 2020 + i
    );

    useEffect(() => {
        const getDashboardData = () => {
            setLoading(true);
            axiosClient.get(`/project-officer/analytics?year=${selectedYear}`)
                .then((response) => {
                    const res = response.data.data;
                    setDashboardData(res);
                    
                    // Create analytics cards data
                    const cards = [
                        {
                            title: "Total Beneficiaries",
                            count: res.totalBeneficiaries,
                            icon: "users",
                            color: "primary",
                        },
                        {
                            title: "Submitted Cases",
                            count: res.totalCases,
                            icon: "file-text",
                            color: "secondary",
                        },
                        {
                            title: "Cases In-Review",
                            count: res.inReviewCases,
                            icon: "clock",
                            color: "warning",
                        },
                        {
                            title: "Approved Cases",
                            count: res.approvedCases,
                            icon: "check-circle",
                            color: "success",
                        },
                        {
                            title: "Delivered Cases",
                            count: res.deliveredCases,
                            icon: "truck",
                            color: "info",
                        },
                        {
                            title: "Declined Cases",
                            count: res.declinedCases,
                            icon: "x-circle",
                            color: "danger",
                        }
                    ];
                    
                    setAnalyticsData(cards);
                    
                    // Update chart data
                    setChartData({
                        options: {
                            ...chartData.options,
                            xaxis: {
                                categories: res.casesSubmittedOverTime.months
                            }
                        },
                        series: [{
                            name: "Cases",
                            data: res.casesSubmittedOverTime.cases
                        }]
                    });
                    
                    setLoading(false);
                })
                .catch((error) => {
                    toast.error(error.response?.data?.message || 'Error fetching dashboard data');
                    setLoading(false);
                });
        };

        getDashboardData();
    }, [selectedYear]);

    return (
        <>
        <div className="container-fluid">
        <div className="page-header">
          <div className="row">
            <div className="col">
              <div className="page-header-left">
                <h3>Dashboard</h3>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">
                      <i data-feather="home"></i>
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Dashboard</li>
                  <li className="breadcrumb-item active">Default</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-8 xl-100">
            <div className="row">
              {/* Analytics Cards */}
              {analyticsData.map((item, index) => (
                  <div key={index} className="col-sm-6 col-xl-4 col-lg-6">
                      <div className={`card o-hidden border-0`}>
                          <div className={`bg-${item.color} b-r-4 card-body`}>
                              <div className="media static-top-widget">
                                  <div className="align-self-center text-center">
                                      <i data-feather={item.icon}></i>
                                  </div>
                                  <div className="media-body">
                                      <span className="m-0">{item.title}</span>
                                      <h4 className="mb-0 counter">
                                          {item.count}
                                      </h4>
                                      <i className={`icon-bg fa fa-${item.icon}`}></i>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              ))}

              {/* Year Selector and Chart */}
              <div className="col-xl-12 xl-100">
                  <div className="card">
                      <div className="card-header">
                          <h5>Cases Overview</h5>
                          <div className="pull-right">
                              <select 
                                  className="form-select"
                                  value={selectedYear}
                                  onChange={(e) => setSelectedYear(e.target.value)}
                              >
                                  {years.map(year => (
                                      <option key={year} value={year}>
                                          {year}
                                      </option>
                                  ))}
                              </select>
                          </div>
                      </div>
                      <div className="card-body">
                          <Chart
                              options={chartData.options}
                              series={chartData.series}
                              type="area"
                              width="100%"
                          />
                      </div>
                  </div>
              </div>
            </div>
          </div>
          <div className="col-xl-4 xl-100">
            <div className="card">
              <div className="card-header">
                <h5>OVERALL CASES ANALYTICS</h5>
              </div>
              <div className="card-body">
                <ul className="list-group list-group-flush">
                    <li className="list-group-item d-flex justify-content-between align-items-center">
                        Pending
                        <span className="badge bg-primary rounded-pill">
                            {dashboardData?.overallAnalytics?.pending || 0}
                        </span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center">
                        In Review
                        <span className="badge bg-warning rounded-pill">
                            {dashboardData?.overallAnalytics?.inReview || 0}
                        </span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center">
                        Approved
                        <span className="badge bg-success rounded-pill">
                            {dashboardData?.overallAnalytics?.approved || 0}
                        </span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center">
                        Delivered
                        <span className="badge bg-info rounded-pill">
                            {dashboardData?.overallAnalytics?.delivered || 0}
                        </span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center">
                        Declined
                        <span className="badge bg-danger rounded-pill">
                            {dashboardData?.overallAnalytics?.declined || 0}
                        </span>
                    </li>
                </ul>
              </div>
            </div>
                <div className="card user-card">
                    <div className="card-body">
                        <div className="online-user">
                        <h5 className="font-primary f-18 mb-0">Online</h5>
                        </div>
                        <div className="user-card-image">
                        <img
                            className="img-fluid rounded-circle image-radius"
                            src={user.photo || "../assets/images/avtar/user.jpeg"}
                            alt=""
                        />
                        </div>
                        <div className="user-deatils text-center">
                        <h5>{user.first_name + " "+ user.last_name}</h5>
                        <h6 className="mb-0">{user.email}</h6>
                        </div>
                        <div className="user-badge text-center">
                        <Link
                            className="badge rounded-pill badge-light active"
                            to="/edit-profile"
                        >
                            Profile
                        </Link>
                        {/* <a
                            className="badge rounded-pill badge-light"
                            href="index.html#"
                        >
                            Ui
                        </a>
                        <a
                            className="badge rounded-pill badge-light"
                            href="index.html#"
                        >
                            Xi
                        </a> */}

                        </div>
                       
                    </div>
                </div>
            </div>
         
            <div className="col-md-6">
                <div className="card height-equal">
                <div className="card-header card-header-border">
                    <div className="row">
                    <div className="col-sm-7">
                        <h5>Recent Beneficiaries</h5>
                    </div>
                    <div className="col-sm-5">
                        <div className="pull-right right-header">
                        <div className="onhover-dropdown">
                            <button
                            className="btn btn-primary btn-pill"
                            type="button"
                            >
                            All{" "}
                            <span className="pe-0">
                                <i className="fa fa-angle-down"></i>
                            </span>
                            </button>
                            <div className="onhover-show-div right-header-dropdown">
                            <a className="d-block" href="index.html#">
                                Order
                            </a>
                            <a className="d-block" href="index.html#">
                                Download
                            </a>
                            <a className="d-block" href="index.html#">
                                Trash
                            </a>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                <div className="card-body recent-notification">
                    { dashboardData.recentBeneficiaries && dashboardData.recentBeneficiaries.map((data)=>(
                        <Link to={`view-beneficiary/${data.id}`} style={{color:"inherit"}}>
                        <div className="media">
                        <h6>{data.registered_at}</h6>
                        <div className="media-body">
                            <span>{data.name}</span>
                            <p className="f-12">{data.by}</p>
                        </div>
                        </div>
                        </Link>
                    ))}
                </div>
                </div>
            </div>
          <div className="col-xl-6">
            <div className="card height-equal">
              <div className="card-header card-header-border">
                <div className="row">
                  <div className="col-sm-6">
                    <h5>Recent Cases</h5>
                  </div>
                  <div className="col-sm-6">
                    <div className="pull-right right-header">
                      <span>Month</span>
                      <span>
                        <button className="btn btn-primary btn-pill">
                          Today
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="new-users">

                        {
                        dashboardData.recentCases &&
                        dashboardData.recentCases.map((cas)=>{
                            return (
                                <div className="media">
                                    <img
                                        className="rounded-circle image-radius m-r-15" style={{height:'60px'}}
                                        src={cas.beneficiary.photo || '../assets/images/user/6.jpg'}
                                        alt=""
                                    />
                                    <div className="media-body">
                                        <h6 className="mb-0 f-w-700">{cas.beneficiary.first_name + " "+ cas.beneficiary.last_name}</h6>
                                        <p>{cas.title}</p>
                                    </div>
                                    <span className="pull-right">
                                        <Link className="btn btn-pill btn-outline-light" to={`/view-beneficiary/${cas.beneficiary_id}`}>
                                        view
                                        </Link>
                                    </span>
                                </div>
                            )
                        })
                        }
   


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        </>
    )
}

export default ProjectOfficer
